import { ComboBox } from 'src/design-system/ui'

/** Workspace identity and navigation stay owned by the portal layout. */
export const BusinessPortalWorkspacePicker = ({
  currentPm,
  loading,
  onChange,
  workspaces,
}: {
  currentPm: string | null
  loading: boolean
  onChange: (pm: string | null) => void
  workspaces: readonly { pmName: string; displayName: string }[]
}) => {
  const items = workspaces.map(({ pmName, displayName }) => ({
    id: pmName,
    label: `${displayName} (${pmName})`,
  }))
  const selectedKey = items.some(({ id }) => id === currentPm)
    ? currentPm
    : null

  return (
    <div className="ds:min-w-0">
      <ComboBox
        className="ds:min-w-0 ds:w-full"
        label="Property manager"
        placeholder="Search property managers..."
        items={items}
        selectedKey={selectedKey}
        onSelectionChange={(key) => {
          if (key !== null && key !== currentPm) onChange(key)
        }}
        emptyMessage={loading ? 'Loading property managers...' : undefined}
      />
    </div>
  )
}
